import React from 'react';
import ActivityIndicator from '../../ActivityIndicator';
import { Box, Grid, Paper, Typography, makeStyles } from '@material-ui/core';
import { WorstPdvs } from '../../../hooks/freights/useGetFreightStatistics';
import { convertMinutesToHours } from '../../../utils/formatTime';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    border: '2px solid #fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  title: {
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '1.7rem',
    color: '#1c2434',
    fontWeight: 600,
  },
  header: {
    marginBottom: '1rem',
    textAlign: 'left',
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: '0.2rem',
  },
  text: {
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1rem',
    color: '#1c2434',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  paragraph: {
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: 500,
    color: '#1c2434',
    fontSize: '1rem',
    lineHeight: '1rem',
    textAlign: 'center',
  },
  progressContainer: {
    position: 'relative',
    marginRight: theme.spacing(1),
    backgroundColor: '#eff4fb',
    height: '40px',
    borderRadius: '0px 4px 4px 0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
}));

interface Props {
  data: WorstPdvs[];
  loading: boolean;
}

const TableCardMercados: React.FC<Props> = ({ data, loading }) => {
  const classes = useStyles();

  const uniqueCorporateNames = data.filter(
    (pdv, index, unitPdvs) =>
      index ===
      unitPdvs.findIndex(
        unitPdv => unitPdv.corporateName === pdv.corporateName,
      ),
  );

  if (loading) {
    return <ActivityIndicator />;
  }

  return (
    <Paper className={classes.root}>
      <Typography className={classes.title} variant="h6" gutterBottom>
        5 Piores PDV's
      </Typography>
      <Grid container spacing={1} className={classes.header}>
        <Grid item xs={5}>
          <Typography
            variant="subtitle1"
            className={classes.text}
            style={{ color: '#64748B', marginLeft: '8px' }}
          >
            PDV's
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            variant="subtitle1"
            className={classes.paragraph}
            style={{ color: '#64748B' }}
          >
            Tempo de espera
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            variant="subtitle1"
            className={classes.paragraph}
            style={{ color: '#64748B' }}
          >
            Devolução
          </Typography>
        </Grid>
      </Grid>
      {uniqueCorporateNames.map((pdv, index) => (
        <Grid container spacing={1} className={classes.container} key={index}>
          <Grid item xs={6}>
            <Box className={classes.progressContainer}>
              <Typography
                className={classes.text}
                style={{ marginLeft: '8px' }}
              >
                {pdv.corporateName}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body1" className={classes.paragraph}>
              {pdv?.waitingTime !== null
                ? convertMinutesToHours(Number(pdv.waitingTime).toFixed(2))
                : 'Sem dados'}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body1" className={classes.paragraph}>
              {pdv.cancelledCount}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Paper>
  );
};

export default TableCardMercados;
